module.exports = __webpack_public_path__ + "static/delta60-screenshot-1-e80abcd95ea39b1a78eb453e1701785b.png";